<template>
  <div>
    <div class="video-container">
      <video class="full-screen-video" :id="'RemoteUser'"></video>
    </div>

    <div class="small-video">
      <div class="video-player" :id="'user-' + uid"></div>
    </div>

    <div class="v-footer" align="center">
      <v-btn @click="endCall()" color="red" dark class="text-capitalize"
        >End Call</v-btn
      >
      <v-btn
        @click="toggleMic"
        icon
        :color="MicText == 'on mic' ? '#EE4B2B' : 'primary'"
      >
        <v-icon>{{
          MicText == "on mic" ? "mdi-microphone-off" : "mdi-microphone"
        }}</v-icon>
      </v-btn>
      <v-btn
        @click="toggleCamera"
        icon
        :color="CameraText == 'on camera' ? '#EE4B2B' : 'primary'"
      >
        <v-icon>{{
          CameraText == "on camera" ? "mdi-video-off" : "mdi-video"
        }}</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import AgoraRTC from "agora-rtc-sdk-ng";

const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

export default {
  data() {
    return {
      localStream: null,
      client: null,
      uid: null,
      remoteUserFullScreen: null,
      MicText: "Mic off",
      CameraText: "Off Camera",
    };
  },
  mounted() {
    this.joinStream();
  },
  methods: {
    async joinAndDisplayLocalStream() {
      client.on("user-published", this.handleUserJoined);
      client.on("user-left", this.handleUserLeft);

      let UID = await client.join(
        this.$store.getters.get_chat_list.agora_app_id,
        this.$store.getters.get_chat_list.agora_channel_name,
        this.$store.getters.get_chat_list.agora_token,
        null
      );

      this.uid = UID;

      this.localStream = await AgoraRTC.createMicrophoneAndCameraTracks();

      await this.localStream[1].play(`user-${UID}`);
      await client.publish(this.localStream);
    },
    async joinStream() {
      await this.joinAndDisplayLocalStream();
    },
    async handleUserJoined(user, mediaType) {
      await client.subscribe(user, mediaType);
      if (mediaType === "video") {
        let remoteVideoTrack = user.videoTrack;
        const playerContainer = document.getElementById("RemoteUser");
        remoteVideoTrack.play(playerContainer);
      }
      if (mediaType === "audio") {
        user.audioTrack.play();
      }
    },
    async handleUserLeft(user) {
      if (this.remoteUserFullScreen === user.uid) {
        this.remoteUserFullScreen = null;
      }
    },
    async toggleMic() {
      if (this.localStream[0].muted) {
        await this.localStream[0].setMuted(false);
        this.MicText = "off mic";
      } else {
        await this.localStream[0].setMuted(true);
        this.MicText = "on mic";
      }
    },
    async toggleCamera() {
      if (this.localStream[1].muted) {
        await this.localStream[1].setMuted(false);
        this.CameraText = "off camera";
      } else {
        await this.localStream[1].setMuted(true);
        this.CameraText = "on camera";
      }
    },
    async endCall() {
      if (this.localStream) {
        for (let i = 0; i < this.localStream.length; i++) {
          this.localStream[i].stop();
          this.localStream[i].close();
        }
      }
      this.$store.commit("SET_MOTORIST_AGAIN", false);
      this.$router.push("/Chat");
      await client.leave();
    },
  },
};
</script>

<style>
.video-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: black;
}

.full-screen-video {
  transform: rotate(-90deg);
  width: 730px;
  height: 900px;
  object-fit: cover;
}

.small-video {
  position: absolute;
  bottom: 16px !important;
  right: 16px !important;
  width: 240px !important;
  height: 160px !important;
}

.video-player {
  height: 100%;
  width: 100%;
}

.v-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
